module.exports = __webpack_public_path__ + "img/goal.a273b738.png";